import { UserProcessVisit, Pagination } from '@interfaces';

export interface SearchOfficeVisitsOpts {
  startDate: string;
  endDate: string;
  visitAssistantId?: string | null;
  visitsOfForeignersAssignedToEmployeeId?: string | null;
  voivodeshipsIds?: string[];
  onlyMyOfficeVisits?: boolean;
}

export interface GetVisitsListOpts extends Pagination {
  startDate: string;
  endDate: string;
  visitAssistantId?: string | null;
  showOnlyMyOfficeVisits: boolean;
  visitsType: UserProcessVisit['eventType'];
  voivodeshipsIds?: string[];
}
